import { useState } from "react"
import {
	IconCheckOutline18 as Check,
	IconCopyOutline18 as CopyIcon,
} from "nucleo-ui-outline-18"
import { useCopyToClipboard, useDebounce } from "react-use"

import type { SidebarSectionCopyButtonComponent } from "@productlane/api/src/browser"
import { cn } from "@productlane/lib/src/cn"
import { IconButton, Tooltip } from "@productlane/ui"

import { SIDEBAR_TRAILING_ICON_PULL } from "../shared/sidebar-group"

interface Props {
	component: SidebarSectionCopyButtonComponent
}

export function CopyButtonComponent({ component }: Props) {
	const [, copy] = useCopyToClipboard()
	const [isCopied, setIsCopied] = useState(false)
	useDebounce(
		() => {
			setIsCopied(false)
		},
		1000,
		[isCopied],
	)
	return (
		<Tooltip label={component.tooltip} enabled={!!component?.tooltip}>
			<IconButton
				variant="ghost"
				className={cn(
					"text-tertiary hover:bg-gray-150 dark:hover:bg-gray-800",
					SIDEBAR_TRAILING_ICON_PULL,
				)}
				iconClassName="h-3.5 w-3.5"
				Icon={isCopied ? Check : CopyIcon}
				onClick={() => {
					copy(component.value)
					setIsCopied(true)
				}}
			/>
		</Tooltip>
	)
}
